import React from "react";

export const hasSubscription = (account, subscriptionName) => {
  const flags = account?.flags || [];
  return flags.some((flag) => flag?.name === subscriptionName);
};

export const hasOpsSubscription = (account) => {
  return hasSubscription(account, "ops-subscription");
};

export const hasCRMSubscription = (account) => {
  return hasSubscription(account, "crm-subscription");
};

export const SubscriptionRequiredNotice = ({ featureName }) => {
  return (
    <div className="uk-alert">
      {featureName} Subscription Required. Contact RueBaRue support to enable
      this feature.
    </div>
  );
};

const OpsSubscriptionRequired = () => {
  return <SubscriptionRequiredNotice featureName="Ops" />;
};

export const CRMSubscriptionRequired = () => {
  return <SubscriptionRequiredNotice featureName="CRM" />;
};

export default OpsSubscriptionRequired;